export const NET_DELAY = 100000;
export const PAGE_SIZE = 20;
